import React from 'react';
import { applyComponentTheme } from '../../../theme';
import Panel, { PanelProps } from '../LabelledPanel';
import { getPanelColors, PanelOptions } from './predefinedStyles';

export type PredefinedPanelProps = {
  panelType: PanelOptions;
} & Omit<PanelProps, 'colors'>;

/**
 * Panel component with predefined types to determine styling.
 *
 * @param panelType - type of either SUCCESS | NEUTRAL | ERROR | INFO | WARNING | NONE, all with preset colors and transparency.
 * See 'Panel' component for descriptions of other params.
 */

const PredefinedPanel: React.FC<PredefinedPanelProps> = ({ panelType, ...props }) => {
  const colors = getPanelColors(panelType);

  return <Panel colors={colors} {...props} />;
};

export default applyComponentTheme(PredefinedPanel, 'PredefinedPanel');
